import React, { useState } from "react";
import "../Styles/Home.css";
import one from "../Assets/experiences/1.png";
import back from "../Assets/back.svg";
import two from "../Assets/experiences/2.png";
import three from "../Assets/experiences/3.png";
import four from "../Assets/experiences/4.png";
import five from "../Assets/experiences/5.png";
import six from "../Assets/experiences/6.png";
import seven from "../Assets/experiences/7.png";
import eight from "../Assets/experiences/8.png";
import logoMain from "../Assets/logoNH7.png";


const Experiences = () => {


  return (
    <div>
      <div>
          <a href="/" className="fBack">
            <img src={back} className="backBtn" alt="back button"></img>
          </a>
        </div>
      <section className="height_custom">
      <div className="content_div_exp">
            <a href="/">
              <img src={logoMain} className="logoMain_pages" alt="nh7 Weekender logo"></img>
            </a>
              <div className="exp_main_block">
                <img src={one} className="exp_img" alt="Speakeasy bar"></img>
                <img src={two} className="exp_img" alt="Mojito Pop Up Van"></img>
                <img src={three} className="exp_img" alt="Tiki Bar"></img>
                <img src={four} className="exp_img" alt="13 Mood Mera food alne"></img>
                <img src={five} className="exp_img" alt="Flea market"></img>
                <img src={six} className="exp_img" alt="Ferris wheel"></img>
                <img src={seven} className="exp_img" alt="Just dance"></img>
                <img src={eight} className="exp_img" alt="Photo ops"></img>
              </div>
          </div>
      </section>
    </div>
  );
};

export default Experiences;
